import React, { useEffect, useState } from 'react'

function DevelopmentBanner() {
  const [isVisible, setIsVisible] = useState(true)
  const [lastScrollY, setLastScrollY] = useState(0)

  useEffect(() => {
    // Initial State setzen basierend auf aktueller Scroll-Position
    const initialScrollY = window.scrollY
    setIsVisible(initialScrollY < 10)
    setLastScrollY(initialScrollY)
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY
      
      // Wenn der User oben ist (scrollY < 10), Banner anzeigen
      if (currentScrollY < 10) {
        setIsVisible(true)
      } 
      // Wenn der User nach unten scrollt, Banner verstecken
      else if (currentScrollY > lastScrollY && currentScrollY > 50) {
        setIsVisible(false)
      }
      // Wenn der User nach oben scrollt, Banner wieder anzeigen
      else if (currentScrollY < lastScrollY) {
        setIsVisible(true)
      }
      
      setLastScrollY(currentScrollY)
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [lastScrollY])

  // Klasse am Body setzen für CSS-Selektoren
  useEffect(() => {
    if (isVisible) {
      document.body.classList.remove('banner-hidden')
    } else {
      document.body.classList.add('banner-hidden')
    }
    return () => {
      document.body.classList.remove('banner-hidden')
    }
  }, [isVisible])

  return (
    <div className={`dev-banner ${isVisible ? 'visible' : 'hidden'}`}>
      <div className="container">
        <div className="dev-banner-content">
          <span className="dev-banner-icon">🚧</span>
          <span className="dev-banner-text">
            Diese App befindet sich noch in der Entwicklungsphase
          </span>
        </div>
      </div>
    </div>
  )
}

export default DevelopmentBanner
